var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "frame" }, [
    _c("div", { staticClass: "row q-mb-md" }, [
      _c(
        "div",
        { staticClass: "col-12 text-center" },
        [
          _c("q-btn", {
            staticClass: "link-scorm",
            attrs: {
              dense: "",
              label: _vm.$t("cant_watch_click_here"),
              icon: "fal fa-eye",
              color: "primary",
              type: "a",
              target: "_blank",
              href: this.activity.scorm_url
            }
          })
        ],
        1
      )
    ]),
    _c("iframe", {
      staticClass: "iframe",
      attrs: {
        src: _vm.activity.scorm_url,
        allow: "autoplay; fullscreen",
        frameBorder: "0"
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }